export const ADD_NEW_CLASS_LABEL = 'Add new class';
export const BLUE_BULLET = '#4c84ec';
export const GREEN_BULLET = '#2cc91e';

export const DEFAULT_MAX_TEXT_LENGTH = 26;

export const PLUGIN_TITLE_COURSES = 'Courses';
export const PLUGIN_TITLE_ACTIVITIES = 'Activities';
export const PLUGIN_TITLE_GLOSSARY = 'Master Glossary';
export const PLUGIN_TITLE_FLASHCARDS = 'Flashcards';
export const PLUGIN_TITLE_CRITICAL_CONCEPTS = 'Critical Concepts';
export const PLUGIN_TITLE_LEARNING_OBJECTIVES = 'Learning Objectives';
export const API_ID_NAME_COURSES = 'API ID : courses';

export const SECTION_TITLE_CREATE_NEW_COURSE = 'Create new course';
export const SECTION_TITLE_IMPORT_COURSE = 'Import Course';

export const EDIT_ACTION_BUTTONS = {
  publish: 'Publish',
  save: 'Save',
  editAsDraft: 'Edit as draft',
};

export const ALERT_CLOSE_LABEL = 'Close alert';

export const CKEDITOR_FIELD_NAME = 'wysiwyg';

export const LOADER_CONTAINER_STYLES = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: 'var(--neutral100)',
  width: '100%',
  height: '100vh',
};

export const LD_CONTEXT_KIND_VALUE = 'user';

export const DEFAULT_BUSINESS_LINE_TYPE = 'insurance_and_securities';

export const LO_AUTO_GENERATION_TOGGLE = {
  label: 'LO auto generation',
  name: 'loAutoGeneration',
  onLabel: 'On',
  offLabel: 'Off',
};
